/**
 * @ngdoc controller
 * @name HomeController
 * @description
 * This component renders the Home section.
 *
 * @memberof rootModule
 */
class HomeController {
  /**
   * Class constructor
   * @param {Object}  $rootScope       To broadcast the tracking events.
   * @param {Service} campaignsService To get the list of campaigns.
   * @param {Service} appConstant      To get the profile loadingTemplates size.
   * @param {Service} errorHandler     To show any errors.
   * @param {Object}  TRACKING_EVENTS  To get the name of the events to be broadcasted.
   * @ignore
   */
  constructor(
    $rootScope,
    campaignsService,
    appConstant,
    errorHandler,
    TRACKING_EVENTS,
  ) {
    'ngInject';

    /**
     * The local reference to the `$rootScope` object.
     * @type {Object}
     */
    this.$rootScope = $rootScope;
    /**
     * The local reference to the `campaignsService` service.
     * @type {Object}
     */
    this.campaignsService = campaignsService;
    /**
     * The local reference to the `errorHandler` service.
     * @type {Object}
     */
    this.errorHandler = errorHandler;
    /**
     * The local reference to the `TRACKING_EVENTS` constant.
     * @type {Object}
     */
    this.TRACKING_EVENTS = TRACKING_EVENTS;
    /**
     * The local reference to the `campaigns` array.
     * @type {?Array}
     */
    this.campaigns = null;
    /**
     * List of place holder; we need a list to iterate on the template.
     * @type {Number}
     */
    this.loadingItems = appConstant.pagination.home.loadingTemplates;
  }
  /**
   * Handle the load of the campaings.
   * @param {Boolean} first flag to get the Campaings
   *                  for the first time or load more.
   */
  _loadCampaings(first) {
    this.campaignsService.load(first)
    .then((campaigns) => {
      this.campaigns = campaigns;
    })
    .catch((err) => this.errorHandler.handleError(err));
  }
  /**
   * Load the first batch of campaings objects.
   */
  $onInit() {
    this._loadCampaings(true);
  }
  /**
   * Handle the infinite scroll load more.
   */
  loadMoreCampaings() {
    this._loadCampaings(false);
  }
  /**
   * Track the click on a Campaign.
   */
  trackClickCampaign() {
    this.$rootScope.$broadcast(this.TRACKING_EVENTS.navigation.clickCampaign);
  }
}

export default HomeController;



// WEBPACK FOOTER //
// ./src/frontend/modules/home/components/home/home.controller.js